import {
  DRIVE_IN_RECEPTION,
  FASTLANE_RECEPTION,
  MODE_BRING,
  MODE_DONT_BRING,
  MODE_IDK,
  TIRE_TYPE_WINTER,
  TYPE_IDK,
  TYPE_TIRES,
  TYPE_WHEELS,
} from '../journey1/definition/business';

export function tireReplacementDisplayText(
  formatMessage,
  tireReplacement
) {

  let tireReplacementText;
  if (!tireReplacement){
    return tireReplacement;
  }

  const selectedTiresBrands =  tireReplacement.selectedTiresBrands || tireReplacement.brands;
  const selectedTireType = tireReplacement.selectedTireType || tireReplacement.tireType;
  const selectedFrontLeftTire = tireReplacement.selectedFrontLeftTire || (tireReplacement.positions && tireReplacement.positions.frontLeft);
  const selectedFrontRightTire = tireReplacement.selectedFrontRightTire || (tireReplacement.positions && tireReplacement.positions.frontRight);
  const selectedBackLeftTire = tireReplacement.selectedBackLeftTire || (tireReplacement.positions && tireReplacement.positions.rearLeft);
  const selectedBackRightTire = tireReplacement.selectedBackRightTire || (tireReplacement.positions && tireReplacement.positions.rearRight);
  const tireWidth = tireReplacement.tireWidth || (tireReplacement.tireSize && tireReplacement.tireSize.width);
  const tireProfile = tireReplacement.tireProfile || (tireReplacement.tireSize && tireReplacement.tireSize.profile);
  const tireDiameter = tireReplacement.tireDiameter || (tireReplacement.tireSize && tireReplacement.tireSize.diameter);


    const typeText =
      selectedTireType === TIRE_TYPE_WINTER
        ? 'customer.journey.step.serviceMobility.tireReplacement.typeWinter'
        : 'customer.journey.step.serviceMobility.tireReplacement.typeSummer';

    const sides = [];
    selectedFrontLeftTire &&
      sides.push(formatMessage({ id: 'customer.journey.recap.tire.frontLeft' }));
    selectedFrontRightTire &&
      sides.push(formatMessage({ id: 'customer.journey.recap.tire.frontRight' }));
    selectedBackLeftTire &&
      sides.push(formatMessage({ id: 'customer.journey.recap.tire.rearLeft' }));
    selectedBackRightTire &&
      sides.push(formatMessage({ id: 'customer.journey.recap.tire.rearRight' }));
    tireReplacementText = formatMessage(
      { id: 'customer.journey.recap.tireReplacementValue' },
      { type: formatMessage({ id: typeText }), sides: sides.join(', ') }
    );
    if (selectedTiresBrands && selectedTiresBrands.length > 0) {
      tireReplacementText = `${tireReplacementText}, ${formatMessage(
        { id: 'customer.journey.recap.tireReplacementBrandsValue' }
      )} ${selectedTiresBrands.join(', ')}`;
    }
    if (tireWidth && tireProfile && tireDiameter) {
      tireReplacementText = `${tireReplacementText}, ${formatMessage(
        { id: 'customer.journey.recap.tireReplacementTireSize' },
        { width: tireWidth, profile: tireProfile, diameter: tireDiameter }
      )} ${tireWidth} / ${tireProfile} R ${tireDiameter}`;
    }
  return tireReplacementText;
}

export function receptionDisplayText(reception) {
  let receptionText;
  if (reception && DRIVE_IN_RECEPTION) {
    receptionText = 'customer.journey.step.dateReception.driveInReception';
  } else if (reception && FASTLANE_RECEPTION) {
    receptionText = 'customer.journey.step.dateReception.fastlaneReception';
  } else {
    receptionText = 'customer.journey.step.dateReception.standardReception';
  }
  return receptionText;
}

export function tireExchangeDisplayText(
  formatMessage,
  tireExchangeType,
  tireExchangeMode
) {
  let tireExchangeTypeText;
  let tireExchangeModeText;
  if (tireExchangeType === TYPE_WHEELS) {
    tireExchangeTypeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.typeWheels',
    });
  } else if (tireExchangeType === TYPE_TIRES) {
    tireExchangeTypeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.typeTires',
    });
  } else if (tireExchangeType === TYPE_IDK) {
    tireExchangeTypeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.typeIdk',
    });
  }
  if (tireExchangeMode === MODE_BRING) {
    tireExchangeModeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.modeYes',
    });
  } else if (tireExchangeMode === MODE_DONT_BRING) {
    tireExchangeModeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.modeNo',
    });
  } else if (tireExchangeMode === MODE_IDK) {
    tireExchangeModeText = formatMessage({
      id: 'customer.journey.step.serviceMobility.tireExchange.modeIdk',
    });
  }
  return formatMessage(
    {
      id: 'customer.journey.recap.tireExchangeValue',
    },
    { type: tireExchangeTypeText, mode: tireExchangeModeText }
  );
}



// WEBPACK FOOTER //
// ./src/public/helper/displayTextHelper.js